module.exports = __webpack_public_path__ + "static/img/product_02.24f7499.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_02.jpg
// module id = 24l/
// module chunks = 2